var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlanificar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7823 3.21745C20.681 3.1167 20.5532 3.04695 20.4137 3.01639C20.2742 2.98584 20.1288 2.99574 19.9948 3.04495L3.49476 9.04495C3.35246 9.09892 3.22995 9.19491 3.14349 9.32016C3.05704 9.44542 3.01074 9.59401 3.01074 9.7462C3.01074 9.89839 3.05704 10.047 3.14349 10.1722C3.22995 10.2975 3.35246 10.3935 3.49476 10.4474L10.6948 13.3274L13.5748 20.5274C13.6289 20.6635 13.7216 20.7807 13.8416 20.8647C13.9615 20.9487 14.1034 20.9957 14.2498 20.9999C14.4013 20.9968 14.5484 20.9479 14.6716 20.8595C14.7947 20.7711 14.8882 20.6475 14.9398 20.5049L20.9398 4.00495C20.9909 3.87226 21.0032 3.72777 20.9753 3.58834C20.9474 3.44891 20.8805 3.32028 20.7823 3.21745ZM14.2498 18.1499L12.1573 12.8999L11.0698 11.8724L5.84976 9.74995L18.9973 5.00245L14.2498 18.1499Z",
    fill: "#1E1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlanificar);
export default __webpack_public_path__ + "static/media/Ic_planificar.e216316e4e28ee85fa63281f16e16bd9.svg";
export { ForwardRef as ReactComponent };